import React, { useState, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import classnames from 'classnames';
import { DataTable } from 'redux-database';
import { Shortcut } from '../Shortcut/Shortcut';
import { State } from '../../model/state';

import './DBInspector.css';

function SettingsPage({ settingsObject }: { settingsObject: object }): JSX.Element {
  const settings = Object.keys(settingsObject);
  return (
    <>
      <h2>Settings</h2>
      {settings.map((setting) => (
        <div key={setting} className="db-inspector__setting">
          <div className="db-inspector__setting-name">{setting}</div>
          <div className="db-inspector__setting-value">
            <code>{JSON.stringify(settingsObject[setting])}</code>
          </div>
        </div>
      ))}
    </>
  );
}

function TablePage({ table, name }: { table: DataTable<{ id: string }>; name: string }): JSX.Element {
  const empty = table.ids.length === 0;
  const rows = Object.values(table.byId);
  const rawKeys = new Set<string>();
  rows.forEach((row) => Object.keys(row).forEach((key) => rawKeys.add(key)));
  const keys = Array.from(rawKeys);

  return (
    <>
      <h2>{name}</h2>
      {empty && <div>empty table</div>}
      {!empty && (
        <table className="db-inspector__table">
          <thead>
            <tr>
              {keys.map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                {keys.map((key) => (
                  <td key={key}>
                    <pre>{JSON.stringify(row[key], null, 2)}</pre>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

export function DBInspector(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState('settings');
  const { storeState } = useContext(ReactReduxContext);
  const state = storeState as State;
  const models = ['settings', ...Object.keys(state.data)];
  return (
    <>
      <Shortcut ctrl shift keys="D" onInvoke={() => setOpen((currentlyOpen) => !currentlyOpen)} />
      {open && (
        <div className="db-inspector">
          <div className="db-inspector__window">
            <div className="db-inspector__close" onClick={() => setOpen(false)}>
              ⨉
            </div>
            <nav className="db-inspector__menu">
              {models.map((model) => (
                <span key={model} className={classnames({ active: model === page })} onClick={() => setPage(model)}>
                  {model}
                </span>
              ))}
            </nav>
            {page === 'settings' && <SettingsPage settingsObject={state.settings} />}
            {page !== 'settings' && <TablePage name={page} table={state.data[page]} />}
          </div>
        </div>
      )}
    </>
  );
}
